module.exports = __webpack_public_path__ + "static/media/IPC15PartnersFR.4a6ef928.png";